/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData model module.
 * @module model/MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData
 * @version 1.0
 */
class MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData {
    /**
     * Constructs a new <code>MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData</code>.
     * @alias module:model/MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData
     */
    constructor() { 
        
        MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData} obj Optional instance to populate.
     * @return {module:model/MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData} The populated <code>MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData();

            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('point')) {
                obj['point'] = ApiClient.convertToType(data['point'], 'Number');
            }
            if (data.hasOwnProperty('inviteCode')) {
                obj['inviteCode'] = ApiClient.convertToType(data['inviteCode'], 'String');
            }
            if (data.hasOwnProperty('friendsCount')) {
                obj['friendsCount'] = ApiClient.convertToType(data['friendsCount'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['inviteCode'] && !(typeof data['inviteCode'] === 'string' || data['inviteCode'] instanceof String)) {
            throw new Error("Expected the field `inviteCode` to be a primitive type in the JSON string but got " + data['inviteCode']);
        }

        return true;
    }


}



/**
 * @member {Number} accountNo
 */
MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData.prototype['accountNo'] = undefined;

/**
 * @member {Number} point
 */
MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData.prototype['point'] = undefined;

/**
 * @member {String} inviteCode
 */
MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData.prototype['inviteCode'] = undefined;

/**
 * @member {Number} friendsCount
 */
MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData.prototype['friendsCount'] = undefined;

/**
 * @member {Date} createdAt
 */
MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData.prototype['createdAt'] = undefined;






export default MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData;

